import React, { useContext, useMemo } from 'react';
import { ProductMasterData } from '../../../../../../types/product_master_data/productMasterData';
import ProductMap from '../../../../../components/Map/ProductMap';
import { StockLocationContext } from '../../../../../../context/StockLocationContext';
import { ProductContext } from '../../../../../../context/ProductContext';
import { Product } from '../../../../../../types/product';
import FlexPane from '../../../../../../VentoryUI/components/common/FlexPane';
import LoadingPackage from '../../../../Common/LoadingPackage';
import { UnitOfMeasure } from '../../../../../../types/uom';

interface ProductMapPaneInputProps {
  productMasterData?: ProductMasterData;
  footer: () => JSX.Element;
}

export default function ProductMapPane({ productMasterData: pmd, footer }: ProductMapPaneInputProps) {
  if (!pmd) return null; // TODO: Entity not found

  const { stockLocations, stockLocationsLoading } = useContext(StockLocationContext);
  const { products, productsLoading } = useContext(ProductContext);

  const loading = stockLocationsLoading || productsLoading;

  const locations = useMemo(() => {
    const items = [...(products.get(pmd.id)?.values() || [])].filter(p => stockLocations.has(p.stockLocationId));

    const map = new Map<string, Product[]>();
    items.forEach(product => map.set(product.stockLocationId, [...(map.get(product.stockLocationId) || []), product]));
    return [...map.entries()].map(([key, value]) => {
      return {
        id: key,
        quantity: value.reduce(
          (sum, p) => sum + parseFloat(UnitOfMeasure.toQuantity(pmd.unitOfMeasure, p.unitQuantity)),
          0,
        ),
      };
    });
  }, [products, stockLocations, pmd]);

  return (
    <FlexPane
      content={loading ? <LoadingPackage /> : <ProductMap productMasterData={pmd} locations={locations} />}
      footer={footer()}
    />
  );
}
